<template>
  <div v-if="cover.length > 0">
    <div
      class="report-viewer page-break"
      v-for="(cvr, idx) in cover"
      :key="`cover${idx}`"
    >
      <div class="report-viewer-content report-summary">
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th
                  rowspan="5"
                  colspan="2"
                  class="text-center"
                  style="width: 10px !important"
                >
                  <img src="@/assets/jkr.jpg" class="w-50" />
                  <p class="mb-0 mt-2">JKR MALAYSIA</p>
                </th>
                <th rowspan="5" colspan="10" class="text-center text-wrap">
                  PROSEDUR PENYELIAAN KERJA RUTIN
                </th>
                <td colspan="2">No. Rujukan Dokumen</td>
                <td class="text-center align-middle text-nowrap">
                  JKR.PK(SJ).P. 01
                </td>
              </tr>
              <tr>
                <td colspan="2">No. Keluaran</td>
                <td class="text-center"></td>
              </tr>
              <tr>
                <td colspan="2">No. Pindaan</td>
                <td class="text-center"></td>
              </tr>
              <tr>
                <td colspan="2">Tarikh</td>
                <td class="text-center">
                  {{ reportDate }}
                </td>
              </tr>
              <tr>
                <td colspan="2">Muka Surat</td>
                <td class="text-center">
                  {{ `${idx + 1}/${cover.length}` }}
                </td>
              </tr>
              <tr>
                <th
                  colspan="8"
                  style="width: 50%"
                  class="border-transparent-right border-transparent-bottom"
                >
                  [{{ formName }}]
                </th>
                <th
                  colspan="7"
                  style="width: 50%"
                  class="text-right border-transparent-bottom"
                >
                  LAMPIRAN {{ appendixNumber }}
                </th>
              </tr>
              <tr v-if="reportHeader">
                <th
                  colspan="15"
                  class="h6 py-0 font-weight-bold text-center border-transparent-top border-transparent-bottom"
                >
                  {{ reportHeader }}
                </th>
              </tr>
              <tr>
                <th
                  colspan="15"
                  class="text-center border-transparent-top border-transparent-bottom text-uppercase"
                >
                  LAPORAN HARIAN KERJA PENYENGGARAAN RUTIN
                  <div>
                    <span v-if="title">
                      {{ title }}
                    </span>
                    <span v-else>
                      DAERAH {{ reportDistrict.name }}
                    </span>
                  </div>
                </th>
              </tr>
              <tr>
                <th colspan="15" class="border-transparent-top text-uppercase">
                  DAERAH: {{ reportDistrict.name }}
                </th>
              </tr>
              <tr class="table-active">
                <th
                  class="text-center line-height-1"
                  rowspan="2"
                  style="width: 1%"
                >
                  TARIKH<br />PERIKSA
                </th>
                <th colspan="3" rowspan="2" class="text-nowrap">
                  NO &amp; NAMA LALUAN
                </th>
                <th colspan="3" rowspan="2" class="text-center text-nowrap">
                  KEROSAKAN DIKENALPASTI
                </th>
                <th colspan="5" class="text-center">KATEGORI</th>
                <th rowspan="2" class="text-center line-height-1">
                  TINDAKAN<br />DIAMBIL
                </th>
                <th rowspan="2" class="text-center line-height-1">
                  TARIKH<br />TINDAKAN
                </th>
                <th rowspan="2" class="text-center">CATATAN</th>
              </tr>
              <tr class="table-active">
                <th>R</th>
                <th>BP</th>
                <th>BBP</th>
                <th>K</th>
                <th>AB</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in cvr" :key="c._id">
                <td class="text-center text-nowrap" style="width: 1%">
                  {{ helper.formatDate(c.timestamp, true) }}
                </td>
                <td class="text-uppercase" colspan="3">
                  {{ c.roadName }}
                </td>
                <td colspan="3">
                  {{ c.caption }}
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Rutin'">/</span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Berkala_Pavemen'"
                    >/</span
                  >
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Berkala_Bukan_Pavemen'"
                    >/</span
                  >
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Kecemasan'">/</span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Agensi_Berkenaan'"
                    >/</span
                  >
                </td>
                <td>{{ c.afterCaption }}</td>
                <td class="text-center text-nowrap">
                  {{ helper.formatDate(c.solveDate, true) }}
                </td>
                <td>{{ c.remarks }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="15" class="border-transparent"></td>
              </tr>
              <tr>
                <td colspan="15" class="border-transparent px-0">
                  <div>
                    <p class="font-weight-medium"><u>Nota:</u></p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p>R: Rutin<br />BP: Berkala Pavemen</p>
                      <p>BBP: Berkala Bukan Pavemen<br />K: Kecemasan</p>
                      <p>AB: Agensi Berkenaan</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div
    class="report-viewer page-break"
    v-else-if="!cases || cases.length === 0"
  >
    <div class="report-viewer-content report-summary text-center text-muted">
      No data found
    </div>
  </div>
</template>

<script>
import Helper from "@/helper";

export default {
  props: [
    "cases",
    "title",
    "formName",
    "reportDistrict",
    "reportDate",
    "appendixNumber",
    "reportHeader",
  ],
  data() {
    return {
      cover: [],
      helper: Helper,
    };
  },
  watch: {
    cases: {
      handler() {
        this.cover = [];

        if (this.reportDistrict?.roads?.length > 0) {
          const _roads = [];

          JSON.parse(JSON.stringify(this.reportDistrict.roads)).forEach(
            (road) => {
              const roadData = {
                _id: road._id,
                roadName: road.name,
                timestamp: null,
                caption: null,
                category: null,
                afterCaption: null,
                solveDate: null,
                remarks: null,
              };

              const roadCases = this.cases.filter(
                (c) => c.timestamp && c.road && c.road._id == road._id
              );

              // Sort latest timestamp first
              roadCases.sort((a, b) => {
                const aEpoch = new Date(a.timestamp).getTime();

                const bEpoch = new Date(b.timestamp).getTime();

                return bEpoch - aEpoch;
              });

              if (roadCases.length == 1) {
                // If only 1 case, select that case
                roadData.timestamp = roadCases[0].timestamp;
                roadData.caption = roadCases[0].caption;
                roadData.category = roadCases[0].category;
                roadData.afterCaption = roadCases[0].afterCaption;
                roadData.solveDate = roadCases[0].solveDate;
                roadData.remarks = roadCases[0].remarks;
              } else if (roadCases.length > 1) {
                // If more than 1 case, check if have routine case
                let routineCases = roadCases.filter(
                  (rc) => rc.category == "Rutin"
                );

                if (routineCases && routineCases.length > 0) {
                  // If routine case exists and have more than 1, select first routine case (latest timestamp)
                  roadData.timestamp = routineCases[0].timestamp;
                  roadData.caption = routineCases[0].caption;
                  roadData.category = routineCases[0].category;
                  roadData.afterCaption = routineCases[0].afterCaption;
                  roadData.solveDate = routineCases[0].solveDate;
                  roadData.remarks = routineCases[0].remarks;
                } else {
                  // If no routine case found, select first case
                  roadData.timestamp = roadCases[0].timestamp;
                  roadData.caption = roadCases[0].caption;
                  roadData.category = roadCases[0].category;
                  roadData.afterCaption = roadCases[0].afterCaption;
                  roadData.solveDate = roadCases[0].solveDate;
                  roadData.remarks = roadCases[0].remarks;
                }
              }

              if (roadData.timestamp) {
              _roads.push(roadData);
              }
            }
          );

          // Sort earliest timestamp first, if no timestamp put last
          _roads.sort((a, b) => {
            const aEpoch = a.timestamp
              ? new Date(a.timestamp).getTime()
              : 99999999999999;

            const bEpoch = b.timestamp
              ? new Date(b.timestamp).getTime()
              : 99999999999999;

            return aEpoch - bEpoch;
          });

          _roads.forEach((road) => {
            if (
              this.cover[this.cover.length - 1] &&
              this.cover[this.cover.length - 1].length < 17
            ) {
              this.cover[this.cover.length - 1].push(road);
            } else {
              this.cover.push([road]);
            }
          });

          if (this.cover[this.cover.length - 1].length) {
            this.cover[this.cover.length - 1] = this.cover[
              this.cover.length - 1
            ].concat(
              Array(17 - this.cover[this.cover.length - 1].length).fill({})
            );
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>